const REQUEST_CONFIG = {
	baseUrl: process.env.API_BFF_V2 as string,
	subscriptionKey: process.env.API_BFF_AZURE_SUBSCRIPTION_KEY_V2 as string,
};

export {REQUEST_CONFIG};
